/**
 * Transforms GraphQL search result edges to flattened objects for easier template usage
 * Eliminates the need to drill into .node properties
 */

export interface FlattenedSearchResult {
  cursor: string;
  sitterIdForProfile: string;
  distance: number;
  description: string;
  minRate: number;
  maxRate: number;
  name: string;
  photoUrl: string;
  yearsExperience: number;
  avgRating: number;
  totalRatings: number;
  idv: any;
  badges: any[];
  availability: any;
  city: string;
  stateAbbr: string;
  sitter: {
    id: string;
    name: string;
    photoUrl: string;
    location: {
      cityname: string;
      stateabbr: string;
    };
    idv: any;
    badges: any[];
    nannyProfileVisible: boolean;
    babysitterProfileVisible: boolean;
    nannyProfileCompleted: boolean;
    babysitterProfileCompleted: boolean;
  };
}

/**
 * Transforms GraphQL search edges to flattened objects
 * @param edges - Array of GraphQL search result edges
 * @returns Array of flattened search result objects
 */
export function transformSearchEdges(edges: any[]): FlattenedSearchResult[] {
  if (!edges || !Array.isArray(edges)) {
    return [];
  }

  return edges
    .filter((edge) => edge && edge.node && edge.node.sitter)
    .map((edge) => ({
      cursor: edge.cursor,
      sitterIdForProfile: edge.node.sitter.id,
      distance: parseInt(edge.node.distance, 10),
      description: edge.node.description,
      minRate: edge.node.minRate,
      maxRate: edge.node.maxRate,
      name: edge.node.sitter.name,
      photoUrl: edge.node.sitter.photoUrl,
      yearsExperience: edge.node.yearsExperience,
      avgRating: edge.node.avgRating,
      totalRatings: edge.node.totalRatings,
      idv: edge.node.sitter.idv,
      badges: edge.node.sitter.badges || [],
      availability: edge.node.availability,
      city: edge.node.sitter.location.cityname,
      stateAbbr: edge.node.sitter.location.stateabbr,
      sitter: {
        id: edge.node.sitter.id,
        name: edge.node.sitter.name,
        photoUrl: edge.node.sitter.photoUrl,
        location: {
          cityname: edge.node.sitter.location.cityname,
          stateabbr: edge.node.sitter.location.stateabbr,
        },
        idv: edge.node.sitter.idv,
        badges: edge.node.sitter.badges || [],
        nannyProfileVisible: edge.node.sitter.nannyProfileVisible,
        babysitterProfileVisible: edge.node.sitter.babysitterProfileVisible,
        nannyProfileCompleted: edge.node.sitter.nannyProfileCompleted,
        babysitterProfileCompleted: edge.node.sitter.babysitterProfileCompleted,
      },
    }));
}
